import {
    HttpEditProjectClinicalPresentationsPayload,
    httpEditProjectClinicalPresentations
} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useEditClinicalPresentations = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectClinicalPresentationsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpEditProjectClinicalPresentationsPayload) =>
            httpEditProjectClinicalPresentations({urlParams, payload})
    })
}
